import script from "./GameDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GameDetail.vue?vue&type=script&setup=true&lang=js"

import "./GameDetail.vue?vue&type=style&index=0&id=2f3407e8&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3407e8"]])

export default __exports__